import { render } from "./VehicleItem.vue?vue&type=template&id=0901dfcc&scoped=true&bindings={}"
import script from "./VehicleItem.vue?vue&type=script&lang=ts"
export * from "./VehicleItem.vue?vue&type=script&lang=ts"

import "./VehicleItem.vue?vue&type=style&index=0&id=0901dfcc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0901dfcc"

export default script